import React from 'react';
import { Kanban } from 'lucide-react';

const TasksMockup: React.FC = () => {
  return (
    <div className="bg-gray-50 rounded-2xl p-4 h-[380px] flex flex-col shadow-lg overflow-hidden">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold text-gray-800">Tasks</h3>
        <div className="flex items-center gap-2">
          <button className="h-8 px-3 rounded-full text-xs font-medium bg-white text-gray-700 border border-gray-300 shadow-sm flex items-center gap-1">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Add Task
          </button>
        </div>
      </div>

      {/* Task Board */}
      <div className="flex-1 flex gap-2 overflow-hidden pb-2">
        {/* Task Column */}
        <div className="w-1/3 flex-1">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-gray-300 rounded-full"></div>
              <h4 className="font-semibold text-sm text-gray-700">To Do</h4>
              <span className="text-xs text-gray-500 font-medium">(3)</span>
            </div>
            <button className="text-gray-500 hover:text-gray-700">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="1"></circle>
                <circle cx="19" cy="12" r="1"></circle>
                <circle cx="5" cy="12" r="1"></circle>
              </svg>
            </button>
          </div>

          <div className="space-y-3">
            <div className="p-2 bg-white border border-gray-200 rounded-lg shadow-sm text-xs">
              <h5 className="font-semibold text-xs text-gray-800 mb-0.5">
                Design new landing page
              </h5>
              <p className="text-[10px] text-gray-600 mb-1">Create mockups for homepage redesign</p>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-1">
                  <div className="w-4 h-4 rounded-full bg-blue-500 text-white flex items-center justify-center text-[10px] font-medium">
                    JD
                  </div>
                </div>
                <span className="text-[10px] text-gray-500">Friday</span>
              </div>
            </div>

            <div className="p-2 bg-white border border-gray-200 rounded-lg shadow-sm text-xs">
              <h5 className="font-semibold text-xs text-gray-800 mb-0.5">Social media content</h5>
              <p className="text-[10px] text-gray-600 mb-1">Draft posts for next week's campaign</p>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-1">
                  <div className="w-4 h-4 rounded-full bg-green-500 text-white flex items-center justify-center text-[10px] font-medium">
                    SL
                  </div>
                </div>
                <span className="text-[10px] text-gray-500">Mon</span>
              </div>
            </div>

            <div className="p-2 bg-white border border-gray-200 rounded-lg shadow-sm text-xs">
              <h5 className="font-semibold text-xs text-gray-800 mb-0.5">User interviews</h5>
              <p className="text-[10px] text-gray-600 mb-1">Schedule calls with 5 customers</p>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-1">
                  <div className="w-4 h-4 rounded-full bg-purple-500 text-white flex items-center justify-center text-[10px] font-medium">
                    RK
                  </div>
                </div>
                <span className="text-[10px] text-gray-500">No date</span>
              </div>
            </div>
          </div>
        </div>

        {/* In Progress Column */}
        <div className="w-1/3 flex-1">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-blue-400 rounded-full"></div>
              <h4 className="font-semibold text-sm text-gray-700">In Progress</h4>
              <span className="text-xs text-gray-500 font-medium">(2)</span>
            </div>
            <button className="text-gray-500 hover:text-gray-700">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="1"></circle>
                <circle cx="19" cy="12" r="1"></circle>
                <circle cx="5" cy="12" r="1"></circle>
              </svg>
            </button>
          </div>

          <div className="space-y-3">
            <div className="p-2 bg-white border border-gray-200 rounded-lg shadow-sm text-xs">
              <h5 className="font-semibold text-xs text-gray-800 mb-0.5">API integration</h5>
              <p className="text-[10px] text-gray-600 mb-1">Connect payment processor</p>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-1">
                  <div className="w-4 h-4 rounded-full bg-orange-500 text-white flex items-center justify-center text-[10px] font-medium">
                    MT
                  </div>
                </div>
                <span className="text-[10px] text-gray-500">Tomorrow</span>
              </div>
            </div>

            <div className="p-2 bg-white border border-gray-200 rounded-lg shadow-sm text-xs">
              <h5 className="font-semibold text-xs text-gray-800 mb-0.5">Competitor analysis</h5>
              <p className="text-[10px] text-gray-600 mb-1">Research pricing models</p>
              <div className="flex justify-between items-center">
                <div className="flex-1 flex flex-wrap gap-1 mb-2">
                  <span className="text-[10px] bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded-full">
                    research
                  </span>
                  <span className="text-[10px] bg-gray-100 text-gray-600 px-1.5 py-0.5 rounded-full">
                    marketing
                  </span>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-1">
                  <div className="w-4 h-4 rounded-full bg-blue-500 text-white flex items-center justify-center text-[10px] font-medium">
                    JD
                  </div>
                </div>
                <span className="text-[10px] text-gray-500">Friday</span>
              </div>
            </div>
          </div>
        </div>

        {/* Done Column */}
        <div className="w-1/3 flex-1">
          <div className="flex items-center justify-between mb-3">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <h4 className="font-semibold text-sm text-gray-700">Done</h4>
              <span className="text-xs text-gray-500 font-medium">(2)</span>
            </div>
            <button className="text-gray-500 hover:text-gray-700">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="12" cy="12" r="1"></circle>
                <circle cx="19" cy="12" r="1"></circle>
                <circle cx="5" cy="12" r="1"></circle>
              </svg>
            </button>
          </div>

          <div className="space-y-3">
            <div className="p-2 bg-white border border-gray-200 rounded-lg shadow-sm text-xs">
              <h5 className="font-semibold text-xs text-gray-800 mb-0.5">Feature documentation</h5>
              <p className="text-[10px] text-gray-600 mb-1">Update user guide for new features</p>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-1">
                  <div className="w-4 h-4 rounded-full bg-green-500 text-white flex items-center justify-center text-[10px] font-medium">
                    SL
                  </div>
                </div>
                <span className="text-[10px] text-gray-500">Yesterday</span>
              </div>
            </div>

            <div className="p-2 bg-white border border-gray-200 rounded-lg shadow-sm text-xs">
              <h5 className="font-semibold text-xs text-gray-800 mb-0.5">Budget approval</h5>
              <p className="text-[10px] text-gray-600 mb-1">Get sign-off for Q2 marketing budget</p>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-1">
                  <div className="w-4 h-4 rounded-full bg-purple-500 text-white flex items-center justify-center text-[10px] font-medium">
                    RK
                  </div>
                </div>
                <span className="text-[10px] text-gray-500">Monday</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const tasksMockupData = {
  type: 'Tasks',
  icon: Kanban,
  description:
    'Organize your work with flexible task boards. Create custom columns, track progress visually, set deadlines and priorities, assign team members, and automate workflows for maximum efficiency.',
  mockup: <TasksMockup />,
};

export default TasksMockup;
